module.exports = __webpack_public_path__ + "img/tree-02-a-trunk.1ceef812.png";